import "slick-carousel/slick/slick.scss"
import "slick-carousel/slick/slick-theme.scss"
import "slick-carousel/slick/slick.js"
import 'collection-teaser/scss/_collection-teaser.scss'
import $ from 'jquery'
import MediaQueries from "media-queries"
//import InView from "in-view"
import Mustache from 'mustache'

//PolyFill
var URLSearchParams = require('url-search-params');

const MD_PROXY = require('proxy/proxy_config.js');

const SLIDE_TEMPLATE = require('../assets/slide-template.html');
const SLICK_OPTIONS = {
   autoplay: false,
   adaptiveHeight: false,
   infinite: false,
   speed: 300,
   dots: false,
   mobileFirst: true,
   responsive: [
      {
         breakpoint: MediaQueries.smallBreakpoint,
         settings: {
            arrows: true,
            rows: 1,
            slidesPerRow: 3
         }
      },
      {
         breakpoint: MediaQueries.mediumBreakpoint,
         settings: {
            rows: 1,
            slidesPerRow: 6
         }
      }
  ]
};

export class CollectionTeaser{
   constructor(elem) {
      const $this = $(elem);
      this.sliderInstance = false;
      this.slideInfos = {};
      this.slides = new Array();
      this.slideToJumpTo = 0;
      this.elem = elem;
      this.headlineLevel = $this.data("headline-level");
      this.detailUrl = $this.data("detail-url");
      this.detailLinkText = $this.data("detail-link-text");
      this.jsonSourceUrl = $this.data("ajax-url");
      this.jsonStartParam = $this.data("current-start-param");
      this.jsonStepParam = $this.data("current-step-param");
      this.jsonSearchParam = $this.data("current-search-value-param");
      this.assetUri = new URL( this.jsonSourceUrl );
      this.assetUri = this.assetUri.protocol + "//" + this.assetUri.host + "/";
      this.showCounter = $this.data("show-counter");

      this.currentStartNumber = parseInt(this.jsonStartParam.split("=")[1]);
      this.currentStepNumber = parseInt(this.jsonStepParam.split("=")[1]);
      this.lastSlideFlag = false;
      this.isHighlight = false;
      this.currentJson = {};

      this.check_for_slides();
   }

   check_for_slides(){
      if( !this.isHighlight ){

         const resultXHR = this.get_ajax_result(this.jsonSourceUrl+this.jsonStartParam+this.jsonStepParam+this.jsonSearchParam);

         $.when(resultXHR).then( (result)  => {

            if(result.length === 0 ){
               this.lastSlideFlag = true;
            }

            if( result.objects ){
               result = result.objects;
            }

            this.html_output(result);
         });
      }else{
         this.lastSlideFlag = true;
      }
   }

   get_ajax_result(jsonUrl){

      const objectlist = MD_PROXY.ajax(jsonUrl);

      objectlist.fail( (data) => {
         //Error Handling?
      })

      this.currentJson = objectlist;
      return objectlist;

   }

   html_output(result){

      this.slides = new Array();

      const resultsObject = result;
      const detailUrlArray = this.detailUrl.split("?");
      let detailUrlParams = new URLSearchParams(detailUrlArray[1]);


      if(this.lastSlideFlag){
         $(".fastbackward-button", this.elem).removeClass("hide");
      }else{
         $(".fastbackward-button", this.elem).addClass("hide");
      }

      if(resultsObject[0]){
         this.totalSlideCount = resultsObject[0].total;

         if( !this.totalSlideCount ){
            this.totalSlideCount = result.length;
         }

         resultsObject.map( (resultObject, resultKey) => {

            let imagePath = this.assetUri+resultObject.image;
            //let previewImagePath = imagePath.replace("200w_", "100h_");
            let objekt_id = resultObject.objekt_id;
            let name = resultObject.objekt_name;

            //Highlights are chosen like this.
            if(typeof resultObject.image === "undefined"){
               imagePath = this.assetUri+resultObject.object_image;
               //previewImagePath = imagePath.replace("200w_", "100h_");

               objekt_id = resultObject.object_id;
               name = resultObject.object_name;
            }
            if(typeof resultObject.is_highlight !== "undefined"){
               this.isHighlight = true;
            }


            detailUrlParams.set("dk_object_id", objekt_id);

            const length = 79;

            let newname = "";
            if( name.length > length ){
              newname = name.substring(0,length)+" ...";
            } else {
              newname = name;
            }

            const view = {
               headlineLevel: this.headlineLevel,
               imagePath: imagePath,
               objectId: objekt_id,
               name: newname,
               detailUri: detailUrlArray[0]+"?"+detailUrlParams.toString(),
               detailLinkText: this.detailLinkText
            }



            const singleSlide = Mustache.render(SLIDE_TEMPLATE, view);

            this.slides.push(singleSlide);
         });

         this.init_slider();
      }
   }

   init_slider(){
      if( this.sliderInstance ){
         this.sliderInstance.slick('unslick');
      }

      this.slides.map( (slide, i) => {
         //Append to unitialized Slider
         $(".slider", this.elem).append(slide);
      })

      this.sliderInstance = $(".slider", this.elem).slick(SLICK_OPTIONS);

      if(this.slideToJumpTo !== false){
         this.sliderInstance.slick('slickGoTo', this.slideToJumpTo, true);
      }

      //this.initMdLazyBackgroundImage();
      this.slider_events();
   }


   slider_events(){

      this.sliderInstance.off('beforeChange', $(this.elem));
      this.sliderInstance.on('beforeChange', $(this.elem), (event, slick, currentSlide, nextSlide) => {

         this.slideToJumpTo = nextSlide;

         if( slick.slideCount === nextSlide + 1 ){


            let jsonStartParamArray = this.jsonStartParam.split("=");
            let jsonStepParamArray = this.jsonStepParam.split("=");

            let newStartParam = "";

            //Override Stuff

            jsonStartParamArray[1] = parseInt(jsonStartParamArray[1]) + parseInt(jsonStepParamArray[1]); //Add Amount of Steps to start to get the next e.g. 16 Hits

            this.jsonStartParam = jsonStartParamArray.join("="); //Override Old value

            this.currentStartNumber = jsonStartParamArray[1];


            //this.get_ajax_result( this.jsonSourceUrl+this.jsonStartParam+this.jsonStepParam+this.jsonSearchParam );

            this.check_for_slides();
         }

      });


      this.sliderInstance.off('afterChange', $(this.elem));
      this.sliderInstance.on('afterChange',  $(this.elem), (event, slick, currentSlide) => {
         this.countVisibleSlides();
         $(".counter .current", this.elem).html(parseInt( currentSlide * this.slideInfos.visibileSlides + 1)+"-"+parseInt( (this.slideInfos.currentSlide * this.slideInfos.visibileSlides)) );

         if( (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) && this.lastSlideFlag ){
            $(".fastbackward-button", this.elem).removeClass("hide");
         }else{
            $(".fastbackward-button", this.elem).addClass("hide");
         }
      });

      $(".fastbackward-button", this.elem).off("click");
      $(".fastbackward-button", this.elem).on("click", (e)=>{
         this.sliderInstance.slick('slickGoTo', 0, false);
      });

      this.countVisibleSlides();

      //Kümmert sich um das resizing
      $(window).on('resize', () => {
         setTimeout(this.calculateSizes, 100)
         //this.calculateSizes();
      });
      this.calculateSizes();

      this.sliderInstance.off('resize.slider', $(this.elem) );
      this.sliderInstance.on('resize.slider', $(this.elem), (e) => {//alert();
         this.sliderInstance.slick('setPosition');
         $(window).trigger("resize");
      });

      $("a").on("focus", $(this.elem), function(e){
         $(e.currentTarget).closest(".flip-container").addClass("flip");
      })
      $("a").on("blur", $(this.elem), function(e){
         $(e.currentTarget).closest(".flip-container").removeClass("flip");
      })
   }

   calculateSizes(){
      let maxSlideHeight = $(".slick-slide .slide", this.elem).first().outerHeight();
      $(".slick-slide", this.elem).css("height", maxSlideHeight);
   }


   countVisibleSlides(){
      this.slideInfos.currentSlide = this.sliderInstance.slick("slickCurrentSlide") + 1;
      this.slideInfos.visibileSlides = this.sliderInstance.slick("slickGetOption", "rows") * this.sliderInstance.slick("slickGetOption", "slidesPerRow");

      if( $(".counter", this.elem).length === 0 && this.showCounter === "true" ){
         $(".slider", this.elem).before("<div class='counter'><span class='current'>"+this.slideInfos.currentSlide+"-"+this.slideInfos.visibileSlides+"</span>/<span class='total'>"+this.totalSlideCount+"</span></div>");
      }

   }
}


export default class CollectionTeaserManager{
   constructor(){
      this.collectionTeasers = $('.collection-teaser').toArray().reduce( (a, e) => (
        { [e] : new CollectionTeaser(e),
          ...a
         }
      ), {});
   }
}

//Init Aufruf in framework/collect-teaser_init.js